// @ts-nocheck
import constant from "./constant.js";

function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}

export function hue(a, b) {
  const d = b - a;
  return d
    ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d)
    : constant(isNaN(a) ? b : a);
}

export default function nogamma(a, b) {
  const d = b - a;
  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
}
